import { useState } from 'react';
import ReactModal from 'react-modal';

import { cn } from 'lib/helpers/utility';

import Body from './components/Body';
import Footer from './components/Footer';
import Header from './components/Header';
import { getTypePresets } from './getTypePresets';

/**
 * @param {import('./lib/propTypes').ConfirmProps}
 */

const Confirm = ({
  type = 'confirm',
  icon,
  iconSize = 24,
  iconColor,
  variant,
  title,
  message,
  children,
  primaryBtn,
  secondaryBtn,
  primaryBtnTxt,
  secondaryBtnTxt,
  isOpen = false,
  handleOpen = false, // recommended to use isOpen instead of handleOpen
  handleContinue,
  handleClose,
  loading,
  customClassName,
  overlayClassName = null,
  childrenClassName,
  disabled = false,
  footer,
  isFooter = true,
  showKeepEditingButton,
  showDontShowThisMessageAgain = false,
  ...rest
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const preset = getTypePresets({
    type,
    icon,
    variant,
    title,
    message,
    primaryBtnTxt,
    secondaryBtnTxt,
    showKeepEditingButton
  });
  const finalIcon = preset.icon;
  const finalVariant = preset.variant;
  const finalTitle = preset.title;
  const finalMessage = preset.message;
  const finalPrimaryBtnTxt = preset.primaryBtnTxt;
  const finalSecondaryBtnTxt = preset.secondaryBtnTxt;
  const finalShowKeepEditingButton = preset.showKeepEditingButton;

  return (
    <ReactModal
      isOpen={isOpen || handleOpen}
      onRequestClose={handleClose}
      contentLabel={title}
      ariaHideApp={false}
      className={cn(
        'relative z-[100] w-[460px] rounded-md border border-solid border-neutral-200 bg-white shadow-[0px_0px_16px_0px_rgba(55,65,69,0.08)] outline-none',
        customClassName
      )}
      overlayClassName={cn('ModalOverlay', overlayClassName)}
      {...rest}>
      <Header
        icon={finalIcon}
        iconSize={iconSize}
        iconColor={iconColor}
        variant={finalVariant}
        title={finalTitle}
        message={finalMessage}
        handleClose={handleClose}
        dontShowAgain={dontShowAgain}
        setDontShowAgain={setDontShowAgain}
        showDontShowThisMessageAgain={showDontShowThisMessageAgain}
      />
      <Body body={children} childrenClassName={childrenClassName} />
      <Footer
        footer={footer}
        loading={loading}
        disabled={disabled}
        isFooter={isFooter}
        variant={finalVariant}
        primaryBtn={primaryBtn}
        primaryBtnTxt={finalPrimaryBtnTxt}
        secondaryBtn={secondaryBtn}
        secondaryBtnTxt={finalSecondaryBtnTxt}
        handleClose={handleClose}
        handleContinue={handleContinue}
        showKeepEditingButton={finalShowKeepEditingButton}
      />
    </ReactModal>
  );
};

export default Confirm;
